import { FC } from "react";
import { Tab } from "features/CenterContent/shared/Tabs/useTabsContext";
import { BusTabElement } from "features/CenterContent/shared/Tabs/BusTabElement";
import { TrainTabElement } from "features/CenterContent/shared/Tabs/TrainTabElement";
import { DecisionSupportTabElement } from "features/CenterContent/shared/Tabs/DecisionSupportTabElement";
import { ReserveBusTabElement } from "features/CenterContent/shared/Tabs/ReserveBusTabElement";
import { BackupBusTabElement } from "features/CenterContent/shared/Tabs/BackupBusTabElement";

type TabIdElementProps = {
  tab: Tab;
  index: number;
};

export const TabIdElement: FC<TabIdElementProps> = ({ tab, index }) => {
  switch (tab.type) {
    case "train":
      return <TrainTabElement trainTabs={tab} index={index} />;

    case "bus":
      return <BusTabElement busTabs={tab} index={index} />;

    case "infrastructureEvent":
    case "decision-support":
      return <DecisionSupportTabElement tab={tab} index={index} />;

    case "reservebus":
      return <ReserveBusTabElement reserveBusTabs={tab} index={index} />;

    case "backupbus":
      return <BackupBusTabElement backupBusTabs={tab} index={index} />;
  }
};
